import React, { useEffect, useState } from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const NewsPreviewSection = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const apiUrl = import.meta.env.VITE_API_URL || 'https://m1wfhwazrd.execute-api.us-east-1.amazonaws.com/prod';
                const response = await fetch(`${apiUrl}/news`);
                if (response.ok) {
                    const data = await response.json();
                    // Take only the first 3 items
                    setNews((data.items || []).slice(0, 3));
                }
            } catch (err) {
                console.error('Erro ao buscar notícias para preview:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    if (loading || news.length === 0) return null;

    return (
        <section className="news-preview-section">
            <div className="container">
                <div className="section-header">
                    <h2>Últimas Notícias</h2>
                    <Link to="/noticias" className="view-all-link">
                        Ver todas <ArrowRight size={16} />
                    </Link>
                </div>

                <div className="news-grid preview-grid">
                    {news.map((item) => (
                        <article key={item.id} className="news-card glass-panel">
                            <div className="news-meta">
                                <span className="news-source">{item.source || 'AutoMestre'}</span>
                                <span className="news-date">
                                    <Calendar size={14} />
                                    {new Date(item.publishedAt).toLocaleDateString('pt-BR')}
                                </span>
                            </div>
                            <h3>{item.title}</h3>
                            <p className="news-summary">{item.summary}</p>
                            <a
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-read-more"
                            >
                                Ler mais
                            </a>
                        </article>
                    ))}
                </div>
            </div>

            <style>{`
                .news-preview-section {
                    padding: 4rem 0;
                    position: relative;
                }
                .section-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 2rem;
                }
                .section-header h2 {
                    font-size: 2rem;
                    color: var(--text-light);
                }
                .view-all-link {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    color: var(--primary);
                    text-decoration: none;
                    font-weight: 500;
                    transition: color 0.2s;
                }
                .view-all-link:hover {
                    color: #fff;
                }
                .preview-grid {
                    /* Reuse existing news-grid styles but ensure they are loaded */
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                    gap: 2rem;
                }
                /* Ensure styles from NewsPage.css are available or duplicated here if scoped improperly.
                   Ideally we import the CSS in App or globablly. 
                   For now, since NewsPage.css is imported in App, it should work if classes match.
                */
                .preview-grid h3 {
                   font-size: 1.25rem;
                   margin-bottom: 1rem;
                   color: var(--text-light);
                   line-height: 1.4;
                }
            `}</style>
        </section>
    );
};

export default NewsPreviewSection;
